import { ApplicationConfig, provideBrowserGlobalErrorListeners } from '@angular/core';
import { provideHttpClient, withInterceptors } from '@angular/common/http';
import { provideAnimationsAsync } from '@angular/platform-browser/animations/async';
import { provideRouter } from '@angular/router';
import { provideNzIcons } from 'ng-zorro-antd/icon';
import { en_US, provideNzI18n } from 'ng-zorro-antd/i18n';
import { provideNzNativeDateAdapter } from 'ng-zorro-antd/core/time';
import { NzModalService } from 'ng-zorro-antd/modal';
import {
  API_BASE_URL,
  authInterceptor,
  errorInterceptor,
  PORTAL_NAME,
  refreshTokenInterceptor,
} from '@dlap-ui/core';
import { environment } from '../environments/environment';
import {
  AppstoreOutline,
  ArrowRightOutline,
  BankOutline,
  BranchesOutline,
  CalendarOutline,
  CheckCircleOutline,
  CheckOutline,
  ClockCircleOutline,
  CloseCircleOutline,
  CloseOutline,
  ClusterOutline,
  CustomerServiceOutline,
  DeleteOutline,
  DollarOutline,
  DownOutline,
  DownloadOutline,
  EditOutline,
  EnvironmentOutline,
  ExclamationCircleOutline,
  EyeInvisibleOutline,
  EyeOutline,
  FileOutline,
  FileProtectOutline,
  FilterOutline,
  GiftOutline,
  HomeOutline,
  IdcardOutline,
  InboxOutline,
  InfoCircleOutline,
  KeyOutline,
  LockOutline,
  LoginOutline,
  LogoutOutline,
  MailOutline,
  MenuFoldOutline,
  MenuOutline,
  MenuUnfoldOutline,
  PlayCircleOutline,
  PlusOutline,
  RightOutline,
  SafetyCertificateOutline,
  SafetyOutline,
  SearchOutline,
  StopOutline,
  SwapOutline,
  SyncOutline,
  TeamOutline,
  ThunderboltOutline,
  UndoOutline,
  UserOutline,
  WalletOutline,
  WarningOutline,
} from '@ant-design/icons-angular/icons';
import { appRoutes } from './app.routes';

export const appConfig: ApplicationConfig = {
  providers: [
    provideBrowserGlobalErrorListeners(),
    provideAnimationsAsync(),
    provideHttpClient(withInterceptors([authInterceptor, errorInterceptor, refreshTokenInterceptor])),
    provideRouter(appRoutes),
    provideNzI18n(en_US),
    provideNzNativeDateAdapter(),
    NzModalService,
    { provide: API_BASE_URL, useValue: environment.server },
    { provide: PORTAL_NAME, useValue: 'BANK' },
    provideNzIcons([
      MailOutline,
      LockOutline,
      KeyOutline,
      EyeOutline,
      EyeInvisibleOutline,
      MenuOutline,
      CloseOutline,
      RightOutline,
      DownOutline,
      UserOutline,
      LoginOutline,
      SyncOutline,
      AppstoreOutline,
      CalendarOutline,
      DeleteOutline,
      DollarOutline,
      EditOutline,
      ExclamationCircleOutline,
      FileOutline,
      FilterOutline,
      IdcardOutline,
      InboxOutline,
      LogoutOutline,
      MenuFoldOutline,
      MenuUnfoldOutline,
      PlusOutline,
      SearchOutline,
      TeamOutline,
      UndoOutline,
      WalletOutline,
      WarningOutline,
      DownloadOutline,
      PlayCircleOutline,
      StopOutline,
      BankOutline,
      BranchesOutline,
      CloseCircleOutline,
      ClusterOutline,
      EnvironmentOutline,
      FileProtectOutline,
      GiftOutline,
      HomeOutline,
      SafetyCertificateOutline,
      SwapOutline,
      InfoCircleOutline,
      CheckOutline,
      CheckCircleOutline,
      ClockCircleOutline,
      ArrowRightOutline,
      SafetyOutline,
      ThunderboltOutline,
      CustomerServiceOutline,
    ]),
  ],
};
